import React, { Component, Fragment } from "react";

import Container from "@material-ui/core/Container";
import TabPill from "./TabPill";
import CustomizedProgressBars from "./spinner";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/KeyboardBackspace";
import * as handler from "../Actions/main";
import { connect } from "react-redux";
class OrderDetail extends Component {
  // componentDidMount() {
  //     window.onpopstate  = (e) => {
  //         this.props.history.replace("/");
  //         }

  // }

  // state = {
  //   orderCurrent: [],
  //   orderPast: [],
  //   isLoading: true
  // };
  componentDidMount() {
    if (this.props.status === false) {
      let email = this.props.match.params.email;
      console.log(email);
      this.props.fetchOrec(email);
      //Orec-->Order record
    }

    // axios
    //   .get(
    //     " https://securedapi.confirmtkt.com/api/platform/foodbooking/getallbookings?authToken=OTE3MjA0MTUxMzIzODFoX2pnajY4X2N6cF93XzdqaHNn&provider=RailRestro"
    //   )

    //   .then(response => {
    //     //  list.sort((a, b) => (a.color > b.color) ? 1 : -1)
    //     let oop = response.data.map(e => {
    //       let yr = e.deliveryDate.split("T");
    //       yr[0] = new Date(yr[0]);
    //       yr[0] = yr[0].getTime();
    //       let xr = { ...e, Tstamp: yr[0] };
    //       return xr;
    //     });

    //     oop.sort((b, a) => (a.Tstamp > b.Tstamp ? 1 : -1));

    //     let dateObj = new Date();
    //     let month = dateObj.getUTCMonth() + 1; //months from 1-12
    //     let day = dateObj.getUTCDate();
    //     let year = dateObj.getUTCFullYear();

    //     let today = year + "/" + month + "/" + day;

    //     today = new Date(today);
    //     today = today.getTime();

    //     let x = oop.filter(e => {
    //       let z = e.deliveryDate.split("T");
    //       z[0] = new Date(z[0]);

    //       z[0] = z[0].getTime();

    //       if (today <= z[0]) {
    //         return true;
    //       } else {
    //         console.log(e.deliveryDate);
    //         return false;
    //       }
    //     });

    //     let kl = oop.filter(e => {
    //       let z = e.deliveryDate.split("T");
    //       z[0] = new Date(z[0]);
    //       z[0] = z[0].getTime();

    //       if (today > z[0]) return true;
    //       else return false;
    //     });

    //     this.setState({
    //       orderCurrent: x,
    //       orderPast: kl,
    //       isLoading: false
    //     });
    //   });
  }

  back = () => {
    this.props.history.goBack();
  };

  render() {
    let result;
    if (this.props.isLoading === false) {
      if (this.props.error === false) {
        result = (
          <Fragment>
            <Grid
              container
              alignItems="center"
              spacing={1}
              style={{
                backgroundColor: "#45A04A",
                position: "fixed",
                margin: "0px",
                top: 0,
                zIndex: 100
              }}
            >
              <Grid item xs={2} style={{ marginLeft: "10px" }}>
                <IconButton
                  edge="start"
                  style={{ color: "white" }}
                  onClick={this.back}
                  aria-label="Close"
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
              <Grid item xs={8} style={{ fontSize: "18px", color: "white" }}>
                My Food Orders
              </Grid>
            </Grid>

            <TabPill
              curr={this.props.orderCurrent}
              prev={this.props.orderPast}
            />
          </Fragment>
        );
      } else
        result = (
          <Container style={{ marginTop: "50%", textAlign: "center" }}>
            <span style={{ fontSize: "14px" }}> Failed while fetching </span>
          </Container>
        );
    } else {
      result = (
        <Container>
          <Typography
            variant="h5"
            color="textSecondary"
            align="center"
            style={{ marginBottom: 150 }}
          />
          <div style={{ textAlign: "center", marginBottom: 5 }}>
            <CustomizedProgressBars />
          </div>
          <Typography variant="h5" color="textSecondary" align="center">
            Fetching Food Orders
          </Typography>
        </Container>
      );
    }

    return result;
  }
}
const mapDispatchToProps = dispatch => {
  return {
    fetchOrec: email => dispatch(handler.initOrderRec(email))
  };
};

const mapStateToProps = state => {
  return {
    orderCurrent: state.recordR.orderCurrent,
    orderPast: state.recordR.orderPast,
    error: state.recordR.errorOrec,
    isLoading: state.recordR.isLoadingOrec,
    status: state.recordR.statusOrec
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderDetail);
